import React from "react";
import CustomButton from "../../common/CustomButton";


const TeamFormModal = ({ isOpen, onClose , setTeamName , teamName , handleSubmit , loading}) => {

    
  if (!isOpen) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 transition-opacity duration-300"
      onClick={(e) => e.target === e.currentTarget && onClose()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div className="bg-white flex flex-col gap-6 rounded-lg p-5 w-full max-w-xl relative animate-fade-in-up">
        {/* Header */}
        <div className="flex items-center justify-between bg-slate-50 px-4 py-2 rounded-lg">
          <h2
            id="modal-title"
            className="text-lg font-semibold text-customGreen"
          >
            Create Team Member
          </h2>
          <button
            onClick={onClose}
            className="hover:text-gray-500 border bg-white p-2 text-red-500 transition-colors rounded-full w-9 h-9 flex items-center justify-center"
            aria-label="Close modal"
          >
            <svg
              xmlns="http://www.w3.org/XPath/2000/svg"
              className="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
        {/* Form Content */}
        <div className="flex items-center w-full gap-4 px-10">
          <div className="text-nowrap ">Team Name</div>
          <input
            type="text"
            placeholder="Enter team name"
            maxLength={30}
            value={teamName}
            onChange={(e) => setTeamName(e.target.value)}
            className="w-full rounded-[10px] p-2 input-focus"
          />
        </div>

        {/* {Submit} */}

        <div className="flex items-center mt-5 justify-center gap-4 px-5">
          <CustomButton isDisabled={loading} label={"Create Team"}  onClick={handleSubmit} />
            </div>
      </div>
    </div>
  );
};

export default TeamFormModal;
